import { createStackNavigator } from '@react-navigation/stack';
import React from 'react';

import FriendsHubScreen from '../features/groups/FriendsHubScreen';
import FamilyHubScreen from '../features/groups/GroupsHubScreen';
import GameRoomScreen from '../features/multi-player/screens/GameRoomScreen';
import MultiplayerLobbyScreen from '../features/multi-player/screens/MultiplayerLobbyScreen';
import MultiplayerQuizScreen from '../features/multi-player/screens/MultiplayerQuizScreen';
import MultiplayerResultsScreen from '../features/multi-player/screens/MultiplayerResultsScreen';
import WaitingForOpponentScreen from '../features/multi-player/screens/WaitingForOpponentScreen';
import UnifiedBookSelectionScreen from '../shared/ui/UnifiedBookSelectionScreen';
import UnifiedCategoryScreen from '../shared/ui/UnifiedCategoryScreen';
import UnifiedDifficultyScreen from '../shared/ui/UnifiedDifficultyScreen';
import UnifiedTestamentScreen from '../shared/ui/UnifiedTestamentScreen';

const Stack = createStackNavigator();

const FamiliesAndFriendsHubNavigator = () => (
  <Stack.Navigator initialRouteName="FamilyHub">
    <Stack.Screen name="FamilyHub" component={FamilyHubScreen} options={{ headerShown: false }} />
    <Stack.Screen name="MultiplayerLobby" component={MultiplayerLobbyScreen} options={{ headerShown: false }} />

    <Stack.Screen name="MultiplayerCategory" component={UnifiedCategoryScreen} options={{ headerShown: false }} />
    <Stack.Screen name="MultiplayerTestament" component={UnifiedTestamentScreen} options={{ headerShown: false }} />
    <Stack.Screen name="MultiplayerDifficulty" component={UnifiedDifficultyScreen} options={{ headerShown: false }} />
    <Stack.Screen name="MultiplayerBookSelection" component={UnifiedBookSelectionScreen} options={{ headerShown: false }} />
    <Stack.Screen name="GameRoom" component={GameRoomScreen} options={{ headerShown: false }} />
    <Stack.Screen name="MultiplayerQuiz" component={MultiplayerQuizScreen} options={{ headerShown: false }} />
    <Stack.Screen name="MultiplayerResults" component={MultiplayerResultsScreen} options={{ headerShown: false }} />
    <Stack.Screen name="WaitingForOpponent" component={WaitingForOpponentScreen} options={{ headerShown: false }} />
    <Stack.Screen name="FriendsHub" component={FriendsHubScreen} options={{ headerShown: false }} />
  </Stack.Navigator>
);

export default FamiliesAndFriendsHubNavigator;
